import styled from 'styled-components';

import React from 'react';

const ContainerDiv = styled.div`
    color: ${(props) => props.theme.colorCreateText};
    text-align: center;
    font-family: Poppins, serif;
    font-size: 28px;
    font-weight: 400;
`;
const CreateText = ({ className, children }) => {
    return <ContainerDiv className={className}>{children}</ContainerDiv>;
};

export default CreateText;
